<template>
  <v-card flat>
    {{ $t('in_progress') }}
  </v-card>
</template>

<script>
export default {};
</script>
